export default {
  methods: {
    /**
         * @description 解决微信6.7.4在ios12下出现的bug
         * bug 描述：软键盘出现后导致页面上移，并且不会复原（页面元素错位）
         */
    handleStupidWechat4IOS12Keyboard () {
      let ua = window.navigator.userAgent.toLowerCase()
      let isWx = ua.match(/MicroMessenger/i) == 'micromessenger'
      if (isWx && ua.indexOf('iphone') !== -1) { // 微信浏览器且iphone
        let ver = ua.match(/cpu iphone os (.*?) like mac os/)
        if (ver && ver.length > 1 && ver[1].indexOf('12') !== -1) {
          setTimeout(() => {
            window.scrollTo(0, 0)
          }, 100)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/mixins/hack.js